import {handleActions} from 'redux-actions';

import {
    INGEST_CONFIG_SET_INITIAL_VALUES_FOR_EDITING,
    INGEST_CONFIG_RESET_INITIAL_VALUES_FOR_EDITING,
} from './EditingIngestConfigActions';

export const setInitialValuesForEditingIngestConfig = (state: any, {payload}:any) => {
    if (payload)
        return payload;
    
    return state;
};

export const resetInitialValuesForEditingIngestConfig = () => {
    return initialState;
};

export const initialState = {};

const handlers = {
    [INGEST_CONFIG_SET_INITIAL_VALUES_FOR_EDITING]: setInitialValuesForEditingIngestConfig,
    [INGEST_CONFIG_RESET_INITIAL_VALUES_FOR_EDITING]: resetInitialValuesForEditingIngestConfig,
};

export default handleActions(handlers, initialState);
